import React, { useState } from 'react';
import { CButton, CForm, CInput, CInputGroup, CInputGroupPrepend, CInputGroupText, CSpinner, CAlert } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { freeSet } from "@coreui/icons";
import { ForgotPasswordApi, ResetPasswordApi, VerifyOtpApi } from 'src/api/api';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { toast } from 'react-hot-toast';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Logo from "src/assets/icons/logo-New.png";
import "./ForgotPassword.scss";

function ForgotPassword() {
    const [userEmail, setUserEmail] = useState(null);
    const [otp, setOtp] = useState(null);
    const [password, setPassword] = useState(null);
    const [confirmPassword, setConfirmPassword] = useState(null);

    const [stepText, setStepText] = useState('Forgot Password');
    const [stepSubtext, setStepSubtext] = useState('Enter your email address and we\'ll send you a verification code');
    const [steps, setSteps] = useState(0);
    const [alert, setAlert] = useState(null);
    const [alertType, setAlertType] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [token, setToken] = useState(null);

    let history = useHistory();

    const sendOtp = () => {
        setAlert(null);
        setAlertType(null);

            ForgotPasswordApi({ email: userEmail })
                .then((res) => {
                    if (res.status === 200) {
                    setAlert(res.data.message);
                    setAlertType('success');
                        setToken(res.data.token);
                        setSteps(1);
                    setStepText('Verify OTP');
                    setStepSubtext('Enter the verification code sent to your email');
                    setIsLoading(false);
                    }
                    else {
                        throw new Error(res.data.message);
                    }
                })
                .catch((err) => {
                setAlert(err?.response?.data?.message ?? err.message);
                setAlertType('danger');
                setIsLoading(false);
                })
    }

    const confirmPasswordChange = (confirmPasswordValue) => {
        setConfirmPassword(confirmPasswordValue);
        if (confirmPasswordValue !== password) {
            setAlert('Password and Confirm Password do not match');
            setAlertType('danger');
        } else {
            setAlert(null);
            setAlertType(null);
        }
    }

    const submit = () => {
        setAlert(null)
        setIsLoading(true);
        setAlert(null);
        setAlertType(null);
        
        if (steps === 0) {
            if (userEmail === null || userEmail === '') {
                setIsLoading(false);
                setAlert('Please enter your email');
                setAlertType('danger');
                return;
            }
            sendOtp();

        } else if (steps === 1) {
            VerifyOtpApi({ email: userEmail, otp: otp })
                .then((res) => {
                    if (res.status === 200) {
                        setAlert(res.data.message);
                        setAlertType('success');
                        setSteps(2);
                        setStepText('Reset Password');
                        setStepSubtext('Enter your new password');
                        setIsLoading(false);
                    }
                    else {
                        throw new Error(res.data.message);
                    }
                })
                .catch((err) => {
                    setAlert(err?.response?.data?.message ?? err.message);
                    setAlertType('danger');
                    setIsLoading(false);
                })
        }
        else if (steps === 2) {
            if (password !== confirmPassword) {
                setIsLoading(false);
                setAlert('Passwords do not match');
                setAlertType('danger');
                return;
            }
            ResetPasswordApi({ email: userEmail, password: password, token: token })
                .then((res) => {
                    if (res.status === 200) {
                        history.push('/login');
                        toast.success(`${res.data.message}`, {
                            position: "top-right",
                            duration: 1000,
                        });
                    }
                    else {
                        throw new Error(res.data.message);
                    }
                })
                .catch((err) => {
                    setAlert(err?.response?.data?.message ?? err.message);
                    setAlertType('danger');
                    setIsLoading(false);
                })
        } else {
            setSteps(0);
            setStepText('Forgot Password');
            setStepSubtext('Enter your email address and we\'ll send you a verification code');
            setIsLoading(false);
        }
    }

    return (
        <div className="forgot-password-page">
            <div className="forgot-password-container">
                <div className="forgot-password-card">
                    <div className="forgot-password-header">
                        <div className="forgot-password-logo">
                            <img src={Logo} alt="EBH" className="forgot-password-logo-img" />
                        </div>
                        <h1 className="forgot-password-title">{stepText}</h1>
                        <p className="forgot-password-subtitle">{stepSubtext}</p>
                    </div>

                    {alert && (
                        <div className="forgot-password-alert">
                            <CAlert color={alertType} closeButton onShowChange={() => { setAlert(null); setAlertType(null); }}>
                                {alert}
                            </CAlert>
                        </div>
                    )}

                    <div className="forgot-password-body">
                        <CForm onSubmit={(e) => { e.preventDefault(); submit(); }}>
                            {steps === 0 && (
                                <div className="forgot-password-input-wrapper">
                                    <label className="forgot-password-label">Email</label>
                                    <CInputGroup className="forgot-password-input-group">
                                        <CInputGroupPrepend>
                                            <CInputGroupText className="forgot-password-input-icon">
                                                <CIcon name="cil-user" />
                                            </CInputGroupText>
                                        </CInputGroupPrepend>
                                        <CInput
                                            type="email"
                                            placeholder="Enter your email"
                                            autoComplete="email"
                                            className="forgot-password-input"
                                            value={userEmail || ''}
                                            onChange={(event) => {
                                                setUserEmail(event.target.value);
                                            }}
                                        />
                                    </CInputGroup>
                                </div>
                            )}

                            {steps === 1 && (
                                                    <>
                                    <div className="forgot-password-input-wrapper">
                                        <label className="forgot-password-label">Verification Code</label>
                                        <CInputGroup className="forgot-password-input-group">
                                            <CInputGroupPrepend>
                                                <CInputGroupText className="forgot-password-input-icon">
                                                    <CIcon name="cil-lock-locked" />
                                                </CInputGroupText>
                                            </CInputGroupPrepend>
                                            <CInput
                                                type="text"
                                                placeholder="Enter OTP number"
                                                autoComplete="one-time-code"
                                                className="forgot-password-input"
                                                value={otp || ''}
                                                onChange={(event) => {
                                                    setOtp(event.target.value);
                                                }}
                                                        />
                                        </CInputGroup>
                                    </div>
                                    <div className="forgot-password-resend">
                                        <button
                                            type="button"
                                            className="forgot-password-resend-link"
                                            onClick={sendOtp}
                                        >
                                            Resend OTP
                                        </button>
                                    </div>
                                                    </>
                            )}

                            {steps === 2 && (
                                                        <>
                                    <div className="forgot-password-input-wrapper">
                                        <label className="forgot-password-label">New Password</label>
                                        <CInputGroup className="forgot-password-input-group">
                                            <CInputGroupPrepend>
                                                <CInputGroupText className="forgot-password-input-icon">
                                                    <CIcon name="cil-lock-locked" />
                                                </CInputGroupText>
                                            </CInputGroupPrepend>
                                            <CInput
                                                type="password"
                                                placeholder="Enter new password"
                                                autoComplete="new-password"
                                                className="forgot-password-input"
                                                value={password || ''}
                                                onChange={(event) => {
                                                    setPassword(event.target.value);
                                                }}
                                                            />
                                        </CInputGroup>
                                    </div>
                                    <div className="forgot-password-input-wrapper">
                                        <label className="forgot-password-label">Confirm Password</label>
                                        <CInputGroup className="forgot-password-input-group">
                                            <CInputGroupPrepend>
                                                <CInputGroupText className="forgot-password-input-icon">
                                                    <CIcon name="cil-lock-locked" />
                                                </CInputGroupText>
                                            </CInputGroupPrepend>
                                            <CInput
                                                type="password"
                                                placeholder="Confirm new password"
                                                autoComplete="new-password"
                                                className="forgot-password-input"
                                                value={confirmPassword || ''}
                                                onChange={(event) => {
                                                    confirmPasswordChange(event.target.value);
                                                }}
                                                            />
                                        </CInputGroup>
                                    </div>
                                </>
                            )}

                            <div className="forgot-password-actions">
                                <CButton
                                    type="submit"
                                    className="forgot-password-btn forgot-password-btn-primary"
                                    disabled={isLoading || (steps === 0 && !userEmail) || (steps === 1 && !otp) || (steps === 2 && (!password || !confirmPassword))}
                                >
                                            {isLoading && <CSpinner color="white" size="sm" className="mr-2" />}
                                    {isLoading ? 'Processing...' : stepText}
                                        </CButton>
                            </div>
                                    </CForm>
                    </div>

                    <div className="forgot-password-footer">
                        <Link
                            to={{
                                pathname: `/login`
                            }}
                            className="forgot-password-back-link"
                        >
                            <CIcon content={freeSet.cilArrowLeft} className="forgot-password-back-icon" />
                            Back to Login
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword